import { Capacitor } from "@capacitor/core";
import { PushNotifications } from "@capacitor/push-notifications";

export function isNativePushSupported() {
  return Capacitor.isNativePlatform() && Capacitor.getPlatform() === "android";
}

export async function activateTakofyNativePush(api, onForegroundNotification) {
  if (!isNativePushSupported()) return null;

  await PushNotifications.createChannel({
    id: "takofy_match_alerts",
    name: "Takofy maç bildirimleri",
    description: "Gol, ilk 11, maç başlangıcı ve sonuç bildirimleri",
    importance: 4,
    visibility: 1,
    sound: "default",
    vibration: true,
  });

  const registration = await PushNotifications.addListener("registration", async ({ value }) => {
    await api.post("/football/me/push/native-devices", {
      token: value,
      platform: Capacitor.getPlatform(),
      deviceName: "Takofy Android",
    });
  });
  const registrationError = await PushNotifications.addListener("registrationError", (error) => {
    console.warn("Takofy native push registration error", error);
  });
  const foreground = await PushNotifications.addListener("pushNotificationReceived", (notification) => {
    onForegroundNotification?.(notification);
  });

  let permission = await PushNotifications.checkPermissions();
  if (permission.receive === "prompt") permission = await PushNotifications.requestPermissions();
  if (permission.receive === "granted") await PushNotifications.register();

  return {
    remove: async () => {
      await registration.remove();
      await registrationError.remove();
      await foreground.remove();
    },
  };
}
